import { SkuDTO, SkuPageProp } from '@/types/skuDataBackend';
import isStringDefined from '../is-string-defined';
export function isDefaultSkuDate(date: Date | string | null | undefined) {
  if (!date) {
    return true;
  }
  const skuDate = typeof date === 'string' ? new Date(date) : date;
  return new Date('1970-01-01T00:00:00.000Z').getTime() === skuDate.getTime();
}
function getSkuDate(date?: string | null | Date): string {
  if (!isStringDefined(date) || isDefaultSkuDate(new Date(date))) {
    return '';
  }

  const dateObj = new Date(date);
  if (dateObj.getFullYear() !== 1970) {
    return dateObj.toLocaleDateString('de-DE');
  }
  return '';
}
export function getDistilledYear(
  sku:
    | (Partial<SkuDTO> & Pick<SkuDTO, 'distilledYear'>)
    | (Partial<SkuPageProp> & Pick<SkuPageProp, 'distilledYear'>)
    | string
    | null
    | Date
) {
  if (sku === null) {
    return '';
  }

  if (typeof sku === 'string') {
    return getSkuDate(sku);
  }

  if (sku instanceof Date) {
    return getSkuDate(sku);
  }

  return getSkuDate(sku?.distilledYear);
}

export function getReleaseDate(
  sku:
    | (Partial<SkuDTO> & Pick<SkuDTO, 'releaseDate'>)
    | (Partial<SkuPageProp> & Pick<SkuPageProp, 'releaseDate'>)
    | string
    | null
    | Date
) {
  if (sku === null || !sku) {
    return '';
  }

  if (typeof sku === 'string') {
    return getSkuDate(sku);
  }

  if (sku instanceof Date) {
    return getSkuDate(sku);
  }

  return getSkuDate(sku.releaseDate);
}
